import { AppNotification } from "./app-notification";

export class MissionNotification extends AppNotification {
    constructor(
        public title: string = null,
        public message: string = null,
        public foreground: boolean = false,
        public missionId: number = 0
    ) {
        super(title, message, foreground);
    }
}
